import classNames from "classnames";
import { ReactNode } from "react";

import "./Sidebar.css";

type SidebarProps = {
  isWide?: boolean;
  hasAutoWidth?: boolean;
  isScrollable?: boolean;
  parent?: boolean;
  hat?: ReactNode;
  children: ReactNode;
};

const Sidebar = ({
  children,
  isWide,
  hasAutoWidth,
  isScrollable,
  hat,
  parent,
}: SidebarProps) => {
  return (
    <div
      className={classNames("Sidebar", {
        "Sidebar--wider": isWide,
        "Sidebar--autoWidth": hasAutoWidth,
        "Sidebar--is_scrollable": isScrollable,
        "Sidebar--withParent": parent,
      })}
    >
      <div className="Sidebar__relativeContainer">
        {hat && <div className="Sidebar__titleContainer">{hat}</div>}
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
